import { linksConstants } from "../../constants/linksConstants";

export const footerMenu = {
  copy: `© ${new Date().getFullYear()} DemystData, Ltd.`,
  social: [{ type: "LinkedIn", url: "https://www.linkedin.com/company/demystdata" }],
  columns: [
    {
      header: "Company",
      items: [{ name: "Contact us", url: linksConstants.CONTACT, isExternal: false }],
    },
    {
      header: "Legal",
      items: [
        {
          name: "Privacy Policy",
          shortName: "Privacy",
          url: linksConstants.PRIVACY,
          isExternal: false,
        },
        {
          name: "Accessibility Policy",
          shortName: "Accessibility",
          url: linksConstants.ACCESSIBILITY,
          isExternal: false,
        },
        {
          name: "Terms and Conditions",
          shortName: "Terms",
          url: linksConstants.TERMS,
          isExternal: false,
        },
        {
          name: "Cookie Policy",
          shortName: "Cookies",
          url: linksConstants.COOKIE_POLICY,
          isExternal: false,
        },
        {
          name: "Manage Cookies",
          hideShort: true,
          url: linksConstants.MANAGE_COOKIE,
          isExternal: false,
        },
        {
          name: "Personal Information Request (CA)",
          hideShort: true,
          url: linksConstants.CCPA,
          isExternal: false,
        },
        {
          name: "Data Subject Action Request",
          hideShort: true,
          url: linksConstants.DSAR,
          isExternal: false,
        },
      ],
    },
  ],
};
